import { render, staticRenderFns } from "./CorporationIndex.vue?vue&type=template&id=af771978&scoped=true&"
import script from "./CorporationIndex.vue?vue&type=script&lang=js&"
export * from "./CorporationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af771978",
  null
  
)

export default component.exports